export default __webpack_public_path__ + "static/media/ChevronDown.03b9f7da.svg";